// extracted by mini-css-extract-plugin
export default {"Message":"_404_Message__4OA0x"};